import { DateTime } from "luxon";

interface WeekdayHeaderProps {
  weekDates: string[]; // ISO date strings for Mon–Sun
  locale?: string;
}

export function WeekdayHeader({ weekDates, locale = "ru-RU" }: WeekdayHeaderProps) {
  // Derive short weekday label (e.g., "Пн", "Вт") from the ISO date so slicing the
  // week keeps labels correct.
  return (
    <>
      {weekDates.map((date) => {
        const dt = DateTime.fromISO(date);
        const label = dt.isValid ? dt.setLocale(locale).toFormat("ccc") : "—";
        return (
          <div
            key={date}
            className="flex-1 p-4 flex flex-col items-center text-center border-b bg-white sticky top-0 z-10"
          >
            <div className="font-medium text-sm">{label}</div>
            <div className="text-xs text-gray-500">{dt.isValid ? dt.toISODate() : date}</div>
          </div>
        );
      })}
    </>
  );
}
